import angular from 'angular'

angular.module('pub.raffles.service', []).factory('RaffleService', RaffleService)

/** @ngInject */
function RaffleService($http, $q, API) {
  function list(id, start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL + 'publisher/top_prizes/' + id + '/raffles?start=' + start + '&limit=' + limit,
      )
      .success(defered.resolve)

    return defered.promise
  }

  function get(id) {
    var defered = $q.defer()

    $http.get(API.API_URL + 'publisher/raffles/' + id).success(defered.resolve)

    return defered.promise
  }

  function save(model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'publisher/raffles', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function update(id, model) {
    var defered = $q.defer()

    $http
      .put(API.API_URL + 'publisher/raffles/' + id, model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function remove(id) {
    var defered = $q.defer()

    $http
      .delete(API.API_URL + 'publisher/raffles/' + id)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function searchShinies(t, ch, start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL +
          'publisher/shinies/search?t=' +
          t +
          '&chId=' +
          ch +
          '&start=' +
          start +
          '&limit=' +
          limit,
      )
      .success(defered.resolve)

    return defered.promise
  }

  function addShiny(id, shinyId) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + `publisher/raffles/${id}/shinies/${shinyId}`)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function deleteShiny(id, shinyId) {
    var defered = $q.defer()

    $http
      .delete(API.API_URL + `publisher/raffles/${id}/shinies/${shinyId}`)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function getWinners(id, start, limit) {
    var defered = $q.defer()

    $http
      .get(API.API_URL + `publisher/raffles/${id}/winners?start=${start}&limit=${limit}`)
      .success(defered.resolve)

    return defered.promise
  }

  function doDrawing(id) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + `publisher/raffles/${id}/do_drawing`)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function redraw(id, data) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + `publisher/raffles/${id}/redraw`, data)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  return {
    list: list,
    get: get,
    save: save,
    update: update,
    remove: remove,
    searchShinies,
    addShiny,
    deleteShiny,
    getWinners,
    doDrawing,
    redraw,
  }
}
